import { useCallback, useEffect, useState } from 'react';
import { ErreurApi } from '../lib/api.js';

export interface Chargement<T> {
  donnees: T | null;
  erreur: string | null;
  enCours: boolean;
  recharger: () => Promise<void>;
  /** Remplace les données localement (après une mutation) sans refaire la requête. */
  remplacer: (d: T) => void;
}

/** Chargement d'une ressource avec rechargement manuel. */
export function useChargement<T>(charger: () => Promise<T>, deps: unknown[]): Chargement<T> {
  const [donnees, setDonnees] = useState<T | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(true);
  const recharger = useCallback(async () => {
    setEnCours(true);
    try {
      setDonnees(await charger());
      setErreur(null);
    } catch (e) {
      setErreur(e instanceof ErreurApi ? e.message : 'Impossible de joindre le serveur.');
    } finally {
      setEnCours(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(() => {
    void recharger();
  }, [recharger]);
  return { donnees, erreur, enCours, recharger, remplacer: setDonnees };
}
